(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('propriedadeButtonWeather', PropriedadeButtonWeatherDirective);

  function PropriedadeButtonWeatherDirective() {
    return {
      restrict: 'E',
      templateUrl: 'views/directives/propriedade-button-weather.html',
      scope: {
        active: '<',
        data: '<'
      },
      link(scope, element) {
        element.addClass('btn-group btn-map');

        scope.iconClass = iconClass;

        function iconClass() {
          const { data } = scope;
          let iconClass = 'icon-';
          if (data === 'loading') {
            iconClass = 'fa fa-spinner fa-pulse fa-fw';
          } else if (data !== null && data.list.length) {
            const { icon } = data.list[0].weather[0];
            iconClass += `weather-${icon.substr(0, icon.length - 1)}`;
          } else {
            iconClass += 'thermometer';
          }
          return iconClass;
        }
      }
    };
  }
}());
